import { Injectable } from '@angular/core';

import { Response }   from '@angular/http';
import { ApiService } from '../../root-services/api.service';
import { EditionListService } from '../../editions/edition.service';
import { Observable } from 'rxjs/Observable';

import { BatchCommitInfo }      from '../../models/program/batch-commit-info';
import { UserWelcomeMessage } from '../../models/program/user-welcome-message';
import { BatchResponse } from '../../models/program/batch-response';

@Injectable()
export class CsvService {
  private csvUrl = '/programs';

  constructor(private api: ApiService, private editionListService: EditionListService) { }

  public postCsvUsersTeams(id: number, body: any): Observable<BatchResponse> {
    return this.api.post(`/programs/${id}/actions/upload_users`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public postCsvAssignUsersTeams(id: number, session_id: number, body: any): Observable<BatchResponse> {
    return this.api.post(`/programs/${id}/${session_id}/actions/assign_users`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public postCsvUsersSubscription(editionId: number, body: any): Observable<BatchResponse> {
    return this.api.post(`/editions/${editionId}/actions/upload_users`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public postCsvUsersSession(programId: number, sessionId: number, body: any): Observable<BatchResponse> {
    return this.api.post(`/programs/${programId}/sessions/${sessionId}/actions/upload_users`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public postCsvJourneyUsers(journeyId: number, body: any): Observable<any> {
    return this.api.post(`/journeys/${journeyId}/actions/bulk_upload_users`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public retrieveSubscriptionAndPlanOptions(editionId?: number): Observable<any> {
    if (!editionId) {
      editionId = this.editionListService.getEdition().id;
    }
    return this.api.get(`/editions/${editionId}/actions/get_subscription_options`)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public commitBatchTeams(programId: number, body: {'commit_info': BatchCommitInfo}, welcome?: UserWelcomeMessage, sessionId?: number): Observable<any> {
    let commitBatchBody: any = Object.assign({}, body);
    if (welcome) {
      commitBatchBody.welcome = welcome;
    }
    if (sessionId) {
      commitBatchBody.session_id = sessionId;
    }
    return this.api.post(`/programs/${programId}/actions/commit_user_upload`, commitBatchBody)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public commitBatchAddUsersToEdition(
    editionId: number,
    body: {
      subscription_id: number,
      batchCommitInfo: BatchCommitInfo,
      new_subscription?: {name: string, plan_id: number, end_date: any, start_date: any},
      welcome?: Boolean
    }): Observable<any> {
      return this.api.post(`/editions/${editionId}/actions/commit_user_upload`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public commitBatchAddUsersToSession(
    programId: number,
    sessionId: number,
    body: {
      commit_info: BatchCommitInfo,
    }): Observable<any> {
      return this.api.post(`/programs/${programId}/sessions/${sessionId}/actions/commit_user_upload`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public commitBatchAssignUsersTeams(
    programId: number,
    sessionId: number,
    body: {
      commit_info: BatchCommitInfo,
    }): Observable<any> {
      return this.api.post(`/programs/${programId}/${sessionId}/actions/commit_assign_users`, body)
                   .map((res: Response) => res.json())
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  public getTeamAssignmentFileUrl(programId: number, sessionId: number): string {
    return `${this.api.getBaseUrl()}/programs/${programId}/${sessionId}/nomadic_team_assignments.xlsx`;
  }

  public getSampleFileUrl(programId: number): string {
    return `${this.api.getBaseUrl()}/programs/${programId}/nomadic_user_upload.xlsx`;
  }

  public getSampleFileUrlUploadToEdition(editionId: number): string {
    return `${this.api.getBaseUrl()}/editions/${editionId}/nomadic_user_upload.xlsx`;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/csv.service.ts